import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Broadcaster } from '../components/broadcaster.component';

@Directive({
  selector: '[stickyHeader]'
})
export class StickyHeaderDirective implements OnInit {

  // document
  documentEl: any;
  documentElementTag: string = 'router-container';
  documentScroll: number = 0;
  navbarheight: number = 0;

  // header
  headerElementTag: string = 'thead';
  headerEl: any;
  headerElOriginalYOffset!: number;
  headerElYOffset!: number;
  headerElOriginalStyle: any;
  headerElCellsElementTag: string = 'th';

  // first row
  bodyElementTag: string = 'tbody';
  firstRowEl: any;
  firstRowElOriginalHeight!: number;
  firstRowColumnWidths: number[] = [];
  firstRowCellsElementTag: string = 'td';

  constructor(
    private el: ElementRef,
    private _broadcaster: Broadcaster,
  ) {
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.documentEl = window.document.getElementById(this.documentElementTag);
    // this.getDispositions();
  }

  scrollSubscription!: Subscription;
  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('OnScroll')
      .subscribe(() => {
        this.getDispositions();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  getDispositions() {
    this.documentScroll = this.documentEl.scrollTop;
    if (this.el.nativeElement) {
      let header = this.el.nativeElement.getElementsByTagName(this.headerElementTag);
      let headerRows = header[0].getElementsByTagName('tr');
      if (headerRows.length > 0) this.headerEl = headerRows[0];
      if (this.headerEl) {
        this.headerElYOffset = this.headerEl.getBoundingClientRect().top + this.documentScroll;
        if (this.headerEl.style.position != 'fixed') {
          this.headerElOriginalYOffset = this.headerElOriginalYOffset ? this.headerElOriginalYOffset : this.headerElYOffset;
          this.headerElOriginalStyle = this.headerElOriginalStyle ? this.headerElOriginalStyle : _.cloneDeep(this.headerEl.style);
        }
        let tbody = this.el.nativeElement.getElementsByTagName(this.bodyElementTag)[0];
        this.firstRowEl = tbody.getElementsByTagName('tr')[0];
        if (this.firstRowEl) {
          let cells = this.firstRowEl.getElementsByTagName(this.firstRowCellsElementTag);
          for (let i = 0; i < cells.length; i++) {
            this.firstRowColumnWidths[i] = cells[i].getBoundingClientRect().width;
          }
          this.evaluatePositions();
        } else {
          this.resetHeaderStyle();
        }
      }
    }
  }

  evaluatePositions() {
    if (this.documentScroll !== 0 && (this.documentScroll + this.navbarheight) > this.headerElOriginalYOffset) {
      this.setHeaderStyle();
      this.setHeaderColumnWidths();
    } else {
      this.resetHeaderStyle();
    }
  }

  setHeaderStyle() {
    this.firstRowElOriginalHeight = this.headerEl.style.height;
    // this.firstRowEl.style.alignItems = 'end';
    this.firstRowEl.style.height = '150px';
    if (this.firstRowEl) this.firstRowEl.style.marginTop = '193px';
    this.headerEl.style.backgroundColor = '#f8f8f8';
    this.headerEl.style.position = 'fixed';
    this.headerEl.style.zIndex = 100;
    this.headerEl.style.top = this.navbarheight + 0 + 'px';
    this.headerEl.style.boxShadow = "0px 3px 10px rgba(0, 0, 0, 0.3)";
    this.headerEl.style.width = this.firstRowEl.getBoundingClientRect().width + 'px';
  }

  resetHeaderStyle() {
    if (this.firstRowEl) this.firstRowEl.style.marginTop = '100px';
    this.headerEl.style = _.cloneDeep(this.headerElOriginalStyle);

    if (this.firstRowEl) {
      this.firstRowEl.style.height = this.firstRowElOriginalHeight;
      // this.firstRowEl.style.alignItems = 'center';
    }

  }

  setHeaderColumnWidths() {
    let cells = this.headerEl.getElementsByTagName(this.headerElCellsElementTag);
    this.firstRowColumnWidths.forEach((el, i) => {
      try { cells[i].style.width = el + 'px'; } catch (e) { }
    });
  }
}
